export interface Customization {
  customizationImages: CustomizationImage[]
  printAreas: PrintArea[]
}

export interface CustomizationImage {
  viewId: ViewId
  url: string
  height: number
  width: number
}

export enum ViewId {
  FRONT = 'FRONT',
}

export interface PrintArea {
  type: string
  viewId: ViewId
  placementLabel: string
  dimensions: Dimensions
  coordinates: Coordinates
  methods: Method[]
}

export interface Dimensions {
  width: number
  height: number
  unit: Unit
}

export enum Unit {
  INCHES = 'IN',
  CENTIMETERS = 'CM',
  INCHES_LEGACY = 'INCHES',
  CENTIMETERS_LEGACY = 'CENTIMETERS',
  CENTIMETRES_LEGACY = 'CENTIMETRES',
}

type CanonicalUnit = typeof Unit.INCHES | typeof Unit.CENTIMETERS

/** Display symbol appended to each dimension value, keyed by canonical unit. */
const UNIT_SYMBOLS: Record<CanonicalUnit, string> = {
  [Unit.INCHES]: '"',
  [Unit.CENTIMETERS]: 'cm',
}

/** Normalize an API wire value or legacy alias to a canonical unit. */
export function normalizeUnit(unit: Unit | string | undefined): CanonicalUnit | undefined {
  switch (unit?.toUpperCase()) {
    case Unit.INCHES: // 'IN'
    case Unit.INCHES_LEGACY: // 'INCHES'
      return Unit.INCHES
    case Unit.CENTIMETERS:
    case Unit.CENTIMETERS_LEGACY:
    case Unit.CENTIMETRES_LEGACY:
      return Unit.CENTIMETERS
    default:
      return undefined
  }
}

/** Returns the per-value display symbol for a unit (e.g. `"` or `cm`); empty when unknown. */
export function getUnitSymbol(unit: Unit | string | undefined): string {
  const normalized = normalizeUnit(unit)
  return normalized ? UNIT_SYMBOLS[normalized] : ''
}

export interface Coordinates {
  xPercentFromLeft: number
  yPercentFromTop: number
  widthPercent: number
  heightPercent: number
}

export interface Method {
  linkedVariantId: number
  name: string
  applicationFee: number
  maxColors: number
}
